export default {
  title: 'Beheer uw bedrijf van overal',
  description: 'Meld u aan bij uw bestaande account.',
  form: {
    email: {
      label: 'E-mail',
      placeholder: 'E-mailadres invoeren',
    },
    password: {
      label: 'Wachtwoord',
      placeholder: 'Wachtwoord invoeren',
    },
    error_messages: {
      missing_info: 'Ontbrekende informatie',
      wrong_credentials: 'Onjuist e-mailadres of wachtwoord',
    },
  },
  buttons: {
    login: 'Aanmelden',
    forgot_password: 'Wachtwoord vergeten',
  },
  white_label: {
    title: 'Aanmelden bij uw dashboard',
    form: {
      email: {
        label: 'E-mailadres',
        placeholder: 'u@restaurant.com',
      },
      password: {
        label: 'Wachtwoord',
        placeholder: 'Voer uw wachtwoord in',
      },
    },
    buttons: {
      login: 'Aanmelden',
    },
    intro: {
      eyebrow: 'Orderbeheer',
      headline: 'Beheer uw restaurant van overal.',
      description: "Bestellingen, menu's, openingstijden en uitbetalingen — alles op één plek.",
      features: {
        live: {
          title: 'Live',
          subtitle: 'ordervolging',
        },
        instant: {
          title: 'Direct',
          subtitle: 'menuwijzigingen',
        },
        any_device: {
          title: 'Elk apparaat',
          subtitle: 'telefoon of tablet',
        },
      },
    },
  },
};
